import { Chip } from '@/components/ui';
import { ProfileAvatar } from '@/components/domain/shared/ProfileAvatar';

export interface ChildInfo {
  id: string;
  name: string;
  emoji?: string;
  /** Emoji background — a `bg-*` token class or a literal hex/rgb value. */
  color?: string;
  /** `children.avatar_image_path` — an uploaded photo in the profile bucket. */
  imagePath?: string;
}

export interface ChildFilterPillsProps {
  childList: ChildInfo[];
  selectedId: string | null;
  onSelect: (childId: string | null) => void;
}

export function ChildFilterPills({
  childList,
  selectedId,
  onSelect,
}: ChildFilterPillsProps) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-none">
      <Chip
        label="All"
        selected={selectedId === null}
        onToggle={() => onSelect(null)}
        variant="neutral"
      />
      {childList.map((child) => (
        <Chip
          key={child.id}
          label={child.name}
          selected={selectedId === child.id}
          // YAR-363: go through <ProfileAvatar> like every other child
          // avatar surface, so an uploaded photo wins over the emoji here
          // too. Rendering the emoji inline (the old behaviour) meant a
          // child with a picture kept showing the emoji in these filters.
          avatar={
            <ProfileAvatar
              imagePath={child.imagePath}
              emoji={child.emoji}
              color={child.color}
              initials={child.name.charAt(0).toUpperCase()}
              alt={child.name}
              size="xs"
            />
          }
          onToggle={() => onSelect(child.id)}
        />
      ))}
    </div>
  );
}
